import { render, staticRenderFns } from "./DiagnoseAuswahl.vue?vue&type=template&id=686f2f28&scoped=true"
import script from "./DiagnoseAuswahl.vue?vue&type=script&lang=js"
export * from "./DiagnoseAuswahl.vue?vue&type=script&lang=js"
import style0 from "./DiagnoseAuswahl.vue?vue&type=style&index=0&id=686f2f28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686f2f28",
  null
  
)

export default component.exports